<template>

    <footer class="fuid-footer">

        <b-container>

            <b-row>

                <b-col cols="12">

                    <p class="fuid-footer__brand text-center" v-html="$t('footer.txt')"></p>

                </b-col>

                <b-col cols="12" class="align-intems-center justify-content-center">

                    <ul class="fuid-footer__legal d-flex align-intems-center justify-content-center">
                        <li><a :href="$t('footer.legalurl')" target="_blank">{{ $t('footer.legal') }}</a></li>
                        <li><a :href="$t('footer.privacidadurl')" target="_blank">{{ $t('footer.privacidad') }}</a></li>
                    </ul>

                </b-col>
            
            </b-row>

        </b-container>

    </footer>

</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">

</style>